import { useEffect } from "react";
import FlexContainers from "../Containers/FlexContainers";
import WrapperContainer from "../Containers/WrapperContainer";
import SelectedItemsList from "../DropdownMultiselectInput/SelectedItemsList";
import { IconWrapper, InputContainer, InputTitleWrapper } from "../Input/styled";
import { ChipsWrapper, InputLabel } from "./styled";
import { useRef } from "react";
import PropTypes from "prop-types";

const ChipsInput = ({
  id,
  chips,
  onDelete,
  title,
  innerRef,
  value,
  setValue,
  placeholder,
  disabled,
  icon,
  active,
  setActive,
  TitleComponent
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (active && inputRef.current) {
      inputRef.current.focus();
    } else {
      setValue("");
    }
  }, [active]);

  const handleContainerClick = () => {
    if (!disabled) {
      setActive(true);
      inputRef.current?.focus();
    }
  };

  useEffect(() => {
    const handleFocusOut = (event) => {
      if (active && inputRef.current && !inputRef.current.contains(event.relatedTarget)) {
        inputRef.current?.focus();
      }
    };

    document.addEventListener("focusout", handleFocusOut);
    return () => {
      document.removeEventListener("focusout", handleFocusOut);
    };
  }, [active]);

  return (
    <InputContainer data-testid="input-container" disabled={disabled} ref={innerRef}>
      <WrapperContainer Container={FlexContainers.FlexRowBetween} width="100%">
        {title && (
          <InputTitleWrapper>
            <InputLabel htmlFor={id}>
              {title}
              {TitleComponent}
            </InputLabel>
          </InputTitleWrapper>
        )}
      </WrapperContainer>

      <ChipsWrapper onClick={handleContainerClick}>
        <SelectedItemsList items={chips} onDelete={(id) => onDelete(id)}>
          {(active || chips?.length == 0) && (
            <input
              ref={inputRef}
              id={id}
              data-testid="search-input"
              type={"text"}
              value={value ? value : ""}
              placeholder={chips?.length == 0 ? placeholder : ""}
              onChange={(e) => setValue(e.target.value)}
              onFocus={(e) => setValue(e.target.value)}
              disabled={disabled}
              autoComplete="off"
            />
          )}
        </SelectedItemsList>

        {icon && <IconWrapper>{icon}</IconWrapper>}
      </ChipsWrapper>
    </InputContainer>
  );
};

ChipsInput.propTypes = {
  id: PropTypes.string.isRequired,
  chips: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.string
    })
  ),
  title: PropTypes.string,
  value: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  innerRef: PropTypes.object,
  InputLabel: PropTypes.bool,
  active: PropTypes.bool,
  isRequired: PropTypes.bool,
  onDelete: PropTypes.func,
  setActive: PropTypes.func,
  TitleComponent: PropTypes.node
};

export default ChipsInput;
